import React, { useCallback, useState } from 'react';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { useToast } from './UI/ToastProvider';

interface Props {
  label?: string;
  exportFn: () => Promise<Blob>;
  fileName: string;
}

export const AuditCsvExportButton: React.FC<Props> = ({
  label = 'Exportar como CSV',
  exportFn,
  fileName,
}) => {
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);

  const onClick = useCallback(async () => {
    setLoading(true);
    try {
      const blob = await exportFn();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      addToast(e instanceof Error ? e.message : 'Falha ao exportar', 'error');
    } finally {
      setLoading(false);
    }
  }, [addToast, exportFn, fileName]);

  return (
    <button
      type="button"
      onClick={() => void onClick()}
      disabled={loading}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium rounded-md border border-gray-200 text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-60"
    >
      {loading ? (
        <span className="inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-gray-400 border-t-transparent" />
      ) : (
        <ArrowDownTrayIcon className="h-4 w-4" />
      )}
      {label}
    </button>
  );
};
